module.exports = __webpack_public_path__ + "img/bag_ka.b238350e.png";